import { render } from "./AgencyPreference.vue?vue&type=template&id=086e0e32"
import script from "./AgencyPreference.vue?vue&type=script&lang=js"
export * from "./AgencyPreference.vue?vue&type=script&lang=js"
script.render = render

export default script